import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {FacadeService} from '../../service/facade/facade.service';
import {catchError, map} from 'rxjs/operators';
import {Country} from '../../model/country/country.model';

@Injectable()
export class CountriesResolver implements Resolve<Observable<Country[]>> {
  constructor(private facadeService: FacadeService) {
  }

  resolve(): Observable<Country[]> {
    return this.facadeService.getCountries().pipe(
      map((data) => data),
      catchError(error => {
        return of({error: error});
      })
    );
  }
}
